// Generated by ReScript, PLEASE EDIT WITH CARE


function getMessageTextColor(message_box) {
  return {
          color: message_box.message_box_text_color
        };
}

function getMessageBoxStyle(message_box) {
  return {
          backgroundColor: message_box.message_box_color,
          borderColor: message_box.message_box_color
        };
}

export {
  getMessageTextColor ,
  getMessageBoxStyle ,
  
}
/* No side effect */
